import React from 'react';

const featuredRecipes = [
  {
    id: 1,
    title: '香煎三文鱼配时蔬',
    description: '新鲜大西洋三文鱼搭配柠檬、莳萝和烤蔬菜，简单又健康。',
    time: '30 分钟',
    image: 'https://images.unsplash.com/photo-1467003909585-2f8a72700288?w=600&q=80',
    author: {
      name: '玛丽亚',
      avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&q=80'
    },
    rating: '4.9',
    reviews: 328
  },
  {
    id: 2,
    title: '经典豚骨拉面',
    description: '浓郁猪骨汤底配以软嫩叉烧和温泉蛋，正宗日式风味。',
    time: '45 分钟',
    image: 'https://images.unsplash.com/photo-1569718212165-3a8278d5f624?w=600&q=80',
    author: {
      name: '陈师傅',
      avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&q=80'
    },
    rating: '4.8',
    reviews: 256
  },
  {
    id: 3,
    title: '香煎肉眼牛排',
    description: '完美煎制的牛排配以香草黄油和烤土豆，高级餐厅的味道。',
    time: '35 分钟',
    image: 'https://images.unsplash.com/photo-1546833999-b9f581a1996d?w=600&q=80',
    author: {
      name: '迈克',
      avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&q=80'
    },
    rating: '4.9',
    reviews: 412
  }
];

const Featured = () => {
  return (
    <section className="featured" id="recipes">
      <div className="container">
        <div className="section-header">
          <h2>精选食谱</h2>
          <p>本周最受欢迎的菜品</p>
        </div>
        <div className="recipe-grid">
          {featuredRecipes.map((recipe) => (
            <a href="#" className="recipe-card" key={recipe.id}>
              <div className="recipe-image">
                <img src={recipe.image} alt={recipe.title} />
                <span className="recipe-time">{recipe.time}</span>
              </div>
              <div className="recipe-content">
                <h3>{recipe.title}</h3>
                <p>{recipe.description}</p>
                <div className="recipe-meta">
                  <div className="recipe-author">
                    <img src={recipe.author.avatar} alt={recipe.author.name} />
                    <span>{recipe.author.name}</span>
                  </div>
                  <div className="recipe-rating">{recipe.rating} ({recipe.reviews})</div>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Featured;
